// extracted by mini-css-extract-plugin
export default {"langSwitcher":"LanguageSwitcher_langSwitcher__ZkcvM","langBtn":"LanguageSwitcher_langBtn__TeAmd","active":"LanguageSwitcher_active__kbQy4"};